import { CDN_URL } from './config';

export function getMarkerIcons(category: string) {
  const SELECTED_ICON_URL = `${CDN_URL}/static/1.0.0/${category}-marker-selected.png`;
  const DEFAULT_ICON_URL = `${CDN_URL}/static/1.0.0/${category}-marker.png`;
  const SCALED_SIZE = { width: 40, height: 53 };

  return {
    SELECTED_ICON_URL,
    DEFAULT_ICON_URL,
    SCALED_SIZE,
  };
}
